var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offcanvas-menu offcanvas-menu--active"},[_c('div',{staticClass:"offcanvas-menu__overlay",on:{"click":_vm.overlayClicked}}),_vm._v(" "),_c('transition',{attrs:{"name":"menu-slide"}},[(_vm.displayMenu)?_c('div',{staticClass:"offcanvas-menu__content"},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }